module.exports = __webpack_public_path__ + "static/media/foundation-rffle_14_logo-wall.80a391d7.png";